export const PAGES_NAME = {
    sports: '/kambi',
    casino: '/casino'
};

export const TAG_NAME = 'portal/tracking/landing_page';
